export default {"src":"/_next/static/media/location.6ed00bb0.svg","height":43,"width":42,"blurWidth":0,"blurHeight":0};